// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1_Y5D","cls2":"ToolsMenu-cls2_btk ToolsMenu-cls1_Y5D"};